import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { api } from '~/services/api';
import { ResponseProps } from '../../../utils/helper';
import {
  detalheHistoricoFailure,
  detalheHistoricoRequest,
  detalheHistoricoSuccess,
  historicoFailure,
  historicoRequest,
  historicoSuccess,
} from './actions';
import { HistoricoType } from './types';

interface AreaProps {
  data: any;
}

function* getHistorico({ payload }: ReturnType<typeof historicoRequest>) {
  const { token } = yield select(state => state.auth);

  const { pageNo, pageSize, date, atividade, user, company } = payload.config;

  try {
    const response: ResponseProps = yield call(
      api.get,
      `v1/atividades/historico?pageNo=${pageNo}&pageSize=${pageSize}${
        date ? `&itemDate=${date}` : ''
      }${atividade ? `&itemNm=${atividade}` : ''}${
        user ? `&itemUser=${user}` : ''
      }`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          company: company,
        },
      },
    );

    const data = response.data.map((el: any) => {
      return {
        dataHora: el.change_dt,
        atividade: el.data_treat_operation_nm,
        usuario: el.user_executor,
        id: el.data_operation_id,
        acao: 'any',
        total_itens: el.total_itens,
      };
    });

    yield put(historicoSuccess(data));
  } catch (error) {
    yield put(historicoFailure());
  }
}

function* detalheHistorico({
  payload,
}: ReturnType<typeof detalheHistoricoRequest>) {
  const { token } = yield select(state => state.auth);
  const { date, company, id } = payload.config;

  try {
    const response: ResponseProps = yield call(
      api.get,
      `/v1/atividades/historico/item?opDate=${date}&opId=${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          company: company,
        },
      },
    );

    const area: AreaProps = yield call(api.get, '/v1/areas', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        company: company,
      },
    });

    const tipoTitular = {
      column_name: '',
      old_value: '',
      new_value: '',
    };
    const situacao = {
      column_name: '',
      old_value: '',
      new_value: '',
    };
    const nomeAtividade = {
      column_name: '',
      old_value: '',
      new_value: '',
    };
    const nomeResponsavel = {
      column_name: '',
      old_value: '',
      new_value: '',
    };
    const nomeContatoResponsavel = {
      column_name: '',
      old_value: '',
      new_value: '',
    };
    const tipoConsentimento = {
      column_name: '',
      old_value: '',
      new_value: '',
    };
    const areaData = {
      column_name: '',
      old_value: '',
      new_value: '',
    };

    for (let index = 0; index < response.data.length; index++) {
      const element: any = response.data[index];

      if (element.column_name === 'Tipo de Titular') {
        tipoTitular.column_name = element.column_name;
        tipoTitular.new_value =
          `${tipoTitular.new_value}, ` + element.new_value;
        tipoTitular.old_value =
          `${tipoTitular.old_value}, ` + element.old_value;
      }

      if (element.column_name === 'Situação') {
        situacao.column_name = element.column_name;
        situacao.old_value =
          element.old_value === 'Y' ? 'Ativado' : 'Desativado';
        situacao.new_value =
          element.new_value === 'Y' ? 'Ativado' : 'Desativado';
      }

      if (element.column_name === 'Nome Atividade') {
        nomeAtividade.column_name = element.column_name;
        nomeAtividade.old_value = element.old_value;
        nomeAtividade.new_value = element.new_value;
      }
      if (element.column_name === 'Nome Responsavel') {
        nomeResponsavel.column_name = element.column_name;
        nomeResponsavel.old_value = element.old_value;
        nomeResponsavel.new_value = element.new_value;
      }
      if (element.column_name === 'Nome Contato Responsavel') {
        nomeContatoResponsavel.column_name = element.column_name;
        nomeContatoResponsavel.old_value = element.old_value;
        nomeContatoResponsavel.new_value = element.new_value;
      }

      if (element.column_name === 'Tipo Consentimento') {
        tipoConsentimento.column_name = element.column_name;
        tipoConsentimento.old_value =
          element.old_value === 'Y' ? 'Automático' : 'Manual';
        tipoConsentimento.new_value =
          element.new_value === 'Y' ? 'Automático' : 'Manual';
      }

      if (element.column_name === 'Area') {
        const old_valueIndex = area.data.findIndex(
          (index: any) => index.company_area_id === element.old_value,
        );

        const new_valueIndex = area.data.findIndex(
          (index: any) => index.company_area_id === element.new_value,
        );

        const old_value =
          old_valueIndex !== -1
            ? area.data[old_valueIndex].company_area_ds
            : '';
        const new_value =
          new_valueIndex !== -1
            ? area.data[new_valueIndex].company_area_ds
            : '';

        areaData.column_name = element.column_name;
        areaData.old_value = old_value;
        areaData.new_value = new_value;
      }
    }

    const data = [];

    if (tipoTitular.column_name) data.push(tipoTitular);
    if (situacao.column_name) data.push(situacao);
    if (nomeAtividade.column_name) data.push(nomeAtividade);
    if (nomeResponsavel.column_name) data.push(nomeResponsavel);
    if (nomeContatoResponsavel.column_name) data.push(nomeContatoResponsavel);
    if (tipoConsentimento.column_name) data.push(tipoConsentimento);
    if (areaData.column_name) data.push(areaData);

    yield put(detalheHistoricoSuccess(data));
  } catch (error) {
    yield put(detalheHistoricoFailure());
  }
}

export default all([
  takeLatest(HistoricoType.HISTORICO_RESQUEST, getHistorico),
  takeLatest(HistoricoType.DETALHE_HISTORICO_RESQUEST, detalheHistorico),
]);
